<div
	class="flex flex-col items-center justify-center pt-6 pb-10 xl:pt-16 dark-grey-texts"
>
	<div class="w-[100%] md:w-[80%] xl:w-[60%]">
		<form [formGroup]="this.startFundraiserForm">
			<div *ngIf="currentStep === 1">
				<div
					class="flex flex-col sm:flex-row sm:justify-between sm:items-center pl-6 pr-6 md:pl-0 md:pr-0"
				>
					<h1
						i18n="@@start_fundraiser_first_step_heading"
						class="reset-spacing sm:mb-0 mb-2"
					>
						Let's Get Your Fundraiser Started!
					</h1>
					<span
						i18n="@@start_fundraiser_first_step_number"
						class="text-[#32bf55] font-400 self-end sm:self-auto"
						>Step 1/4</span
					>
				</div>

				<div
					class="flex flex-col justify-start md:rounded-lg p-6 mt-4 border border-solid border-color gap-1"
				>
					<div class="flex flex-col">
						<span
							i18n="@@start_fundraiser_first_step_location_and_language"
							class="text-16 font-500"
							>Where is your fundraiser based, and what language do you
							prefer?</span
						>
						<span
							i18n="@@start_fundraiser_first_step_location_and_language_hint"
							class="w-full text-14"
						>
							Please note: Once you pick a language, it can't be changed
							later</span
						>
					</div>
					<div
						class="flex flex-col md:flex-row justify-between items-center mt-3"
					>
						<div class="flex w-full md:w-[50%]">
							<mat-form-field class="w-full" appearance="outline">
								<mat-label
									i18n="@@fundraiser_createFundraiser_addLocation_label"
									>Location</mat-label
								>
								<input
									required
									class="location"
									#location
									matInput
									formControlName="location"
									(keyup)="onLocationInput(location.value)"
									[matAutocomplete]="locationAuto"
								/>
								<mat-autocomplete #locationAuto="matAutocomplete">
									<mat-option
										*ngFor="let location of locations"
										[value]="location.description"
									>
										{{ location.description }}
									</mat-option>
								</mat-autocomplete>
								<mat-error
									*ngIf="
										startFundraiserForm.controls['location'].errors &&
										startFundraiserForm.controls['location'].errors['location']
									"
									i18n="@@editCreatedBy_inavlidLocation_error"
									>Invalid Location</mat-error
								>
							</mat-form-field>
						</div>
						<div class="flex w-full md:w-[48%]">
							<mat-form-field
								class="w-full"
								appearance="outline"
								id="languageSelect"
							>
								<mat-icon matPrefix>
									<img
										class="w-[24px]"
										src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/{{
											selectedLanguage.value
										}}/public"
									/>
								</mat-icon>
								<mat-select [formControl]="selectedLanguage">
									<mat-option
										*ngFor="let language of languagecodes"
										[value]="language.language_code"
									>
										<div class="flex items-center">
											<img
												class="w-[24px]"
												src="{{ language.languageIcon }}"
											/>&nbsp;&nbsp; {{ language.languageName }}
										</div>
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
					<div class="flex flex-col">
						<span
							class="text-16 font-500"
							i18n="@@startFundraiserPage_describe_your_fundraising_label"
							>What best describes your fundraising cause?</span
						>
					</div>
					<div class="flex flex-col mt-1">
						<mat-chip-listbox
							aria-label="category selection"
							id="chip-list"
							name="chip-list"
							class="whydonate-light"
						>
							<mat-chip
								id="chip"
								name="chip"
								[ngClass]="
									isSelected(category)
										? 'selected-start-category-chip cursor-pointer'
										: 'start-category-chip cursor-pointer'
								"
								*ngFor="let category of _categories"
								[value]="category"
								selected
								(click)="selectCategory(category)"
								color="accent"
							>
								<img matChipAvatar [src]="category.image.src" />
								<caption>
									{{
										category.name
									}}
								</caption>
							</mat-chip>
						</mat-chip-listbox>
					</div>
					<div class="flex flex-col mt-2 mb-2">
						<!-- <mat-divider></mat-divider> -->
					</div>
					<div
						class="flex w-full justify-end sm:static fixed left-0 right-0 z-50 bg-white pt-2 border-t border-gray-200 bottom-0 shadow-[0_-1px_0_0_#e5e7eb]"
					>
						<div class="pr-6 pl-6 pb-3 pt-1 sm:pr-0 sm:pl-0 sm:pb-0 sm:pt-0">
							<button
								mat-flat-button
								color="accent"
								(click)="goToStep(2)"
								[disabled]="
									!startFundraiserForm.controls['category'].valid ||
									!startFundraiserForm.controls['location'].valid ||
									!selectedLanguage?.value
								"
								class="min-h-[48px] h-auto"
							>
								<span
									class="text-20 font-500 p-6"
									i18n="@@customDomain_step1_button_next"
									>Next</span
								>
							</button>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="currentStep === 2">
				<div
					class="flex justify-between items-center pl-6 pr-6 md:pl-0 md:pr-0"
				>
					<h1
						class="dark-grey-texts reset-spacing"
						i18n="@@createFundraiser_heading_label"
					>
						Start Fundraiser
					</h1>
					<span
						class="text-[#32bf55] font-400"
						i18n="@@start_fundraiser_second_step_number"
						>Step 2/4</span
					>
				</div>
				<div
					class="flex flex-col justify-start md:rounded-lg p-6 mt-4 border border-solid border-color gap-1"
				>
					<div class="flex flex-col">
						<span
							class="text-16 font-500"
							i18n="@@start_fundraiser_second_step_heading"
							>Who is this fundraiser for?</span
						>
					</div>
					<div
						class="flex flex-col lg:flex-row justify-between items-stretch mt-3 gap-6 mb-6"
					>
						<div
							class="flex flex-col lg:w-[30%] border rounded-lg p-4 start-card items-start justify-start gap-2 pointer transition-shadow duration-150"
							[ngClass]="{
								'shadow-md border-color hover:shadow-none':
									selectedBeneficiary !== 'yourself'
							}"
							[ngStyle]="
								selectedBeneficiary === 'yourself'
									? { border: '1px solid #32bf55' }
									: {}
							"
							id="yourself"
							(click)="onBeneficiarySelect('yourself')"
						>
							<div class="flex w-full items-center gap-2">
								<img
									class="w-[31px]"
									src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/yourself/public"
								/>
								<span
									class="text-16 font-500"
									i18n="@@homepage_start_fundraising_for_yourself"
								>
									Yourself</span
								>
							</div>
							<div class="flex">
								<span
									class="text-14 font-400"
									i18n="@@homepage_start_fundraising_for_yourself_description"
									>Keep every donation for your cause. Funds go straight to your
									bank account.</span
								>
							</div>
						</div>
						<div
							class="flex flex-col lg:w-[30%] border rounded-lg p-4 start-card items-start justify-start gap-2 pointer transition-shadow duration-150"
							[ngClass]="{
								'shadow-md border-color hover:shadow-none':
									selectedBeneficiary !== 'someoneElse'
							}"
							[ngStyle]="
								selectedBeneficiary === 'someoneElse'
									? { border: '1px solid #32bf55' }
									: {}
							"
							id="someoneElse"
							(click)="onBeneficiarySelect('someoneElse')"
						>
							<div class="flex w-full items-center gap-2">
								<img
									class="w-[31px]"
									src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/someoneElse/public"
								/>
								<span
									class="text-16 font-500"
									i18n="@@beneficiaryChooser_someoneElse"
									>Someone Else</span
								>
							</div>
							<div class="flex">
								<span
									class="text-14 font-400"
									i18n="@@beneficiaryChooser_someoneElse_description"
									>Support a loved one or help a friend in need. Donations can
									be sent directly to them or managed by you.</span
								>
							</div>
						</div>
						<div
							class="flex flex-col lg:w-[30%] border rounded-lg p-4 start-card items-start justify-start gap-2 pointer transition-shadow duration-150"
							[ngClass]="{
								'shadow-md border-color hover:shadow-none':
									selectedBeneficiary !== 'charity'
							}"
							[ngStyle]="
								selectedBeneficiary === 'charity'
									? { border: '1px solid #32bf55' }
									: {}
							"
							id="yourself"
							(click)="onBeneficiarySelect('charity')"
						>
							<div class="flex w-full items-center gap-2">
								<img
									class="w-[31px]"
									src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/charity/public"
								/>
								<span
									class="text-16 font-500"
									i18n="@@homepage_start_fundraising_for_charity"
									>Charity</span
								>
							</div>
							<div class="flex">
								<span
									class="text-14 font-400"
									i18n="@@homepage_start_fundraising_for_charity_description"
									>Raise donations for nonprofits or communities in your
									neighborhood. Donations can be sent directly to the
									organization.</span
								>
							</div>
						</div>
					</div>
					<div
						*ngIf="
							selectedBeneficiary === 'someoneElse' ||
							selectedBeneficiary === 'charity'
						"
					>
						<div class="flex flex-col mt-3 mb-3">
							<span
								class="text-16 font-500"
								i18n="@@create_fundriaser_collecting_money_for_label"
								>Who are you collecting money for?</span
							>
						</div>
						<div class="flex flex-col">
							<mat-form-field
								color="primary"
								appearance="outline"
								class="w-100"
							>
								<mat-label
									i18n="@@donationSummary_received_donation_header_name"
									>Name</mat-label
								>
								<input
									matInput
									formControlName="name"
									#name
									(input)="onNameInput()"
									id="name"
								/>
								<mat-error
									i18n="@@startFundraiser_formField_matError_mustBeBetween1to75"
									*ngIf="
										startFundraiserForm.controls['name']?.errors?.maxlength
									"
								>
									Must be between 1 to 75 characters
								</mat-error>
								<mat-error
									i18n="@@account_formField_matError_mustBealphabets"
									*ngIf="
										startFundraiserForm.controls['name']?.errors &&
										startFundraiserForm.controls['name']?.errors?.pattern
									"
								>
									Must be alphabets only
								</mat-error>
							</mat-form-field>
						</div>
					</div>
					<!-- <div class="flex flex-col">
						<mat-divider></mat-divider>
					</div> -->
					<div
						class="flex w-full pt-3 sm:pt-2 sm:static fixed left-0 right-0 z-50 bg-white border-t border-gray-200 bottom-0 shadow-[0_-1px_0_0_#e5e7eb]"
					>
						<div
							class="pr-6 pl-6 pb-3 sm:pr-0 sm:pl-0 sm:pb-0 justify-between flex w-full"
						>
							<button
								mat-stroked-button
								(click)="goToStep(1)"
								color="accent"
								class="min-h-[48px] h-auto"
							>
								<span class="text-20 font-500 p-6" i18n="@@backButton"
									>Back</span
								>
							</button>

							<button
								mat-flat-button
								color="accent"
								(click)="save()"
								[disabled]="
									startFundraiserForm.invalid || selectedLanguage.invalid
								"
								class="min-h-[48px] h-auto"
							>
								<span class="text-20 font-500 p-6" i18n="@@button_next"
									>Next</span
								>
							</button>
						</div>
					</div>
				</div>
				<div
					class="flex items-center md:rounded-lg pr-4 pl-6 pb-6 pt-4 mt-6 border border-solid border-color gap-2"
				>
					<div class="flex flex-col">
						<img
							class="w-[32px] relative top-[12px] pb-1"
							src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/connectedFundraiser/public"
						/>&nbsp;
					</div>
					<div class="flex flex-col">
						<div class="inline">
							<span
								class="text-16 font-500"
								i18n="@@create_fundraiser_form_note"
							>
								If you are looking for a cause to connect </span
							>&nbsp;
							<a
								class="link-decorate-style pointer"
								(click)="browseFundraiser()"
							>
								<span
									class="text-16 font-500"
									i18n="header_menu_button_searchFundraisers"
									i18n="@@fundraiserContent_searchFundraiser_label"
									>Search Fundraiser</span
								></a
							>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
